import {errorHttpMessage} from "@/utils/errorDecodeUtil"
import operationClient from "@/axiosClients/operationClient"
import dashboardClient from '@/axiosClients/dashboardClient'

export const getFilters = async ({ commit }) => {
    try{        
        const { data:result } = await operationClient.get(`/get-filters/dashboard`)        
        const { data, message, error } = result.result    
        return {data, message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getDashboardInfo = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/periodic-exams${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getDataGraphClosedDays = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/closed-days-data${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getLostDaysByCause = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/lost-days-by-cause${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getAdmissionExamsInfo = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/admission-exams${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getSpecialLabelsFamilies = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/special-labels/families${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getAffectedSystemsTopTwelve = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/affected-system/top-twelve${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}

export const getVaccinationCoverage = async ({ commit }, params) => {
    try{
        const { data:result } = await dashboardClient.get(`/vaccines/coverage${params}`, {cancelOnDashboardUnmount: true})
        return result.result
    } catch(ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}
